import styled from 'styled-components'
import Desktop from '../../components/Desktop'
import { media } from '../../theme'

const StyledDesktop = styled(Desktop)`
  align-items: center;
  height: 100%;
  justify-content: center;
  width: 100%;

  ${media.greaterThan('medium')`
    display: flex;
  `};
`

export default StyledDesktop



// WEBPACK FOOTER //
// ./src/pages/living-room/_StyledDesktop.js